module.exports = __webpack_public_path__ + "img/logo_green.e09423f2.png";